import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { PartyPopper, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refreshWedding } = useAuth();
  const [state, setState] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); refreshWedding(); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* keep polling */ }
      if (tries++ < 10) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="card-lux p-10 max-w-md text-center animate-fade-up" data-testid="payment-result">
        {state === "checking" && <Loader label="Confirmation du paiement…" />}
        {state === "paid" && (<>
          <div className="w-16 h-16 rounded-full bg-sage/15 flex items-center justify-center mx-auto mb-5">
            <PartyPopper className="w-7 h-7 text-sage" /></div>
          <h1 className="font-serif text-3xl">Paiement confirmé</h1>
          <p className="text-stone-600 mt-3">Votre forfait Premium est désormais actif. Toutes les fonctionnalités sont débloquées.</p>
          <Button onClick={() => nav("/app")} className="rounded-full mt-6">Retour au tableau de bord</Button>
        </>)}
        {["error", "timeout"].includes(state) && (<>
          <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-5">
            <XCircle className="w-7 h-7 text-destructive" /></div>
          <h1 className="font-serif text-3xl">Paiement non confirmé</h1>
          <p className="text-stone-600 mt-3">Aucun forfait n'a été activé. Vous pouvez réessayer depuis vos réglages.</p>
          <Button onClick={() => nav("/app/settings")} variant="outline" className="rounded-full mt-6">Retour aux réglages</Button>
        </>)}
      </div>
    </div>
  );
}
